import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useNavigate,
} from "react-router-dom";
import Login from "./Components/Login/Login";
import "./App.css";
import "./custom.css";
import Navbar from "./Components/Navbar/Navbar";
import Dashboard from "./Dashboard/Dashboard";
import Admin from "./Dashboard/Admin-user/Admin";
import Account from "./Dashboard/Account/Account";
import ContractorAccount from "./Dashboard/Account/ContractorAccounts";
import TwofaScan from "./Components/twofa/TwofaScan";

import DisableTwofa from "./Dashboard/TwoFa/DisableTwofa";
import DisableRequest from "./Dashboard/TwoFa/DisableRequest";

import AccountDetail from "./Dashboard/Account/AccountDetail";
import ContractorAccountDetail from "./Dashboard/Account/ContractorAccountDetails";
import PageTwoFa from "./Dashboard/TwoFa/PageTwoFa";

import {
  ProtectedRistrict,
  ProtectedRoute,
  ProtectedTwoFa,
  PublicRoute,
} from "../src/routing/ProtectedRoute";

import Transaction from "./Dashboard/Transaction/Transaction";
import TransactionDetail from "./Dashboard/Transaction/TransactionDetail";
import TransactionDetailUser from "./Dashboard/Transaction/TransactionDetailUser";

import "./App.css";

import Invoice from "./Dashboard/Invoices/Invoice";
import InvoiceDetail from "./Dashboard/Invoices/InvoiceDetail";
import EnableGuide from "./Components/twofa/EnableGuide";
import TwofaCode from "./Components/twofa/TwofaCode";
import CleanerPayment from "./Dashboard/cleanerpayment/CleanerPayment";
import CleanerPaymentView from "./Dashboard/cleanerpayment/CleanerPaymentView";
import EnableTwofa from "./Dashboard/TwoFa/EnableTwofa";
import Coupon from "./Dashboard/coupon/Coupon";
import CreateCoupon from "./Dashboard/coupon/CreateCoupon";
import EditCoupon from "./Dashboard/coupon/EditCoupon";
import TwoFaDisable from "./Dashboard/TwoFa/TwoFaDisable";
import AuthenticationCode from "./Components/Login/AuthenticationCode";
import EditProfile from "./Dashboard/Account/EditProfile";
import Services from "./Dashboard/CreateOrder/Services";
import BookingConfrimation from "./Dashboard/CreateOrder/BookingConfrimation";
import ServicesCommercial from "./Dashboard/CreateOrder/ServicesCommercial";
import SpecialServices from "./Dashboard/CreateOrder/SpecialServices";
import { serviceGet } from "./helper/api";

const App = () => {
  const getCsrfToken = async () => {
    try {
      const csrfTokenRes = await serviceGet("csrf-token", {
        withCredentials: true,
      });
      localStorage.setItem("csrfToken", csrfTokenRes.csrfToken);
    } catch (error) {
      console.log("tokenErrrp", error);
    }
  };

  useEffect(() => {
    getCsrfToken();
  }, []);

  return (
    <>
      {/* <Navbar /> */}
      <Routes>
        <Route element={<PublicRoute restrictedToUnauth={true} />}>
          <Route path="/login" element={<Login />}></Route>
        </Route>

        <Route element={<PublicRoute restrictedToUnauth={false} />}>
          <Route path="/enter-twofa" element={<AuthenticationCode />}></Route>
          <Route path="/twofa-scan" element={<TwofaScan />}></Route>
          <Route path="/twofaguide" element={<EnableGuide />}></Route>
          <Route path="/twofa-code" element={<TwofaCode />}></Route>
        </Route>

        <Route element={<ProtectedRoute />}>
          <Route path="/dashboard" element={<Dashboard />}></Route>
          <Route path="/" element={<Admin />}></Route>
          <Route path="/account" element={<Account />}></Route>
          <Route
            path="/contractoraccount"
            element={<ContractorAccount />}
          ></Route>
          <Route path="/account-detail" element={<AccountDetail />}></Route>
          <Route
            path="/contractoraccount-detail"
            element={<ContractorAccountDetail />}
          ></Route>

          <Route
            path="/contractor-edti-profile"
            element={<EditProfile />}
          ></Route>
          <Route path="/disable-twofa" element={<DisableTwofa />}></Route>
          <Route path="/enable-twofa" element={<EnableTwofa />}></Route>
          <Route path="/disable-request" element={<DisableRequest />}></Route>

          <Route path="/transation" element={<Transaction />}></Route>
          <Route
            path="/transation-detail"
            element={<TransactionDetail />}
          ></Route>
          <Route
            path="transation-detail-user"
            element={<TransactionDetailUser />}
          ></Route>

          <Route path="/invoice" element={<Invoice />}></Route>
          <Route path="/invoice-detail" element={<InvoiceDetail />}></Route>
          <Route path="/cleaner-payment" element={<CleanerPayment />}></Route>
          <Route
            path="/cleaner-payment-detail"
            element={<CleanerPaymentView />}
          ></Route>

          <Route path="/coupon" element={<Coupon />}></Route>
          <Route path="/create-coupon" element={<CreateCoupon />}></Route>
          <Route path="/edit-coupon" element={<EditCoupon />}></Route>

          <Route path="/create-order-services" element={<Services />}></Route>
          <Route
            path="/services-commercial"
            element={<ServicesCommercial />}
          ></Route>
          <Route path="/special-services" element={<SpecialServices />}></Route>
          <Route
            path="/booking-confirmation"
            element={<BookingConfrimation />}
          ></Route>
        </Route>
      </Routes>
      <Routes>
        {/* <Route element={<ProtectedRistrict />}> */}

        <Route path="/enter-twofa-page" element={<PageTwoFa />}></Route>
        <Route path="/twofa-disable" element={<TwoFaDisable />}></Route>

        {/* </Route> */}
      </Routes>
    </>
  );
};

export default App;
